import { isEqual } from "lodash";

import { Product } from "@typings/product/product";

export const areProductsEqual = (a: Product, b: Product): boolean => {
  return (
    a.item.id === b.item.id &&
    isEqual(
      { ...a.configuration, quantity: undefined },
      { ...b.configuration, quantity: undefined }
    )
  );
};
